import { useEffect } from "react";

interface PageMeta {
  title: string;
  description: string;
  keywords?: string;
  canonical?: string;
  schema?: Record<string, unknown> | Record<string, unknown>[];
}

const SITE_NAME = "瓜田热榜";

function upsertMeta(selector: string, attrs: Record<string, string>) {
  let el = document.head.querySelector(selector) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement("meta");
    document.head.appendChild(el);
  }
  Object.entries(attrs).forEach(([key, value]) => {
    el?.setAttribute(key, value);
  });
}

function upsertCanonical(href: string) {
  let el = document.head.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

const SCHEMA_ID = "page-jsonld";

function upsertSchema(schema?: Record<string, unknown> | Record<string, unknown>[]) {
  const existing = document.getElementById(SCHEMA_ID);
  if (existing) existing.remove();
  if (!schema) return;
  const script = document.createElement("script");
  script.type = "application/ld+json";
  script.id = SCHEMA_ID;
  script.text = JSON.stringify(schema);
  document.head.appendChild(script);
}

export default function usePageMeta(meta: PageMeta) {
  useEffect(() => {
    document.title = meta.title;
    upsertMeta('meta[name="description"]', { name: "description", content: meta.description });
    if (meta.keywords) {
      upsertMeta('meta[name="keywords"]', { name: "keywords", content: meta.keywords });
    }
    upsertMeta('meta[property="og:title"]', { property: "og:title", content: meta.title });
    upsertMeta('meta[property="og:description"]', { property: "og:description", content: meta.description });
    upsertMeta('meta[property="og:site_name"]', { property: "og:site_name", content: SITE_NAME });
    upsertMeta('meta[name="twitter:title"]', { name: "twitter:title", content: meta.title });
    upsertMeta('meta[name="twitter:description"]', { name: "twitter:description", content: meta.description });
    if (meta.canonical) upsertCanonical(meta.canonical);
    upsertSchema(meta.schema);
  }, [meta]);
}